import { render, staticRenderFns } from "./ToolbarEditor.vue?vue&type=template&id=12e28666&scoped=true&"
import script from "./ToolbarEditor.vue?vue&type=script&lang=ts&"
export * from "./ToolbarEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ToolbarEditor.vue?vue&type=style&index=0&id=12e28666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e28666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VIcon,VTooltip})
